import StickyJs from "./parts/sticky";
import SwiperInit from "./parts/swiperInit";
import anchorScroll from "anchor-scroll";

//import SmoothScroll from "smooth-scroll";

document.addEventListener("DOMContentLoaded", () => {
  // new SmoothScroll('a[href*="#"]'),
  //   { durationMax: 300, durationMin: 299, offset: -250, easing: "in-out-sine" };

  anchorScroll.init({
    updateUrl: true,
    offset: -250,
    duration: 300,
    ease: "in-out-sine",
  });

  new StickyJs({
    selector: ".social-sticky",
    wrapper: ".data-sticky-container",
    offset: 150,
  });

  const relatedPostsSwiperElems = document.querySelectorAll(
    ".related-posts-swiper"
  );
  const relatedPostsSwiper = new SwiperInit({
    selector: relatedPostsSwiperElems,
    spaceBetween: 32,
    slidesOffsetBefore: 32,
    slidesOffsetAfter: 32,
    slidesPerView: 3,
    breakPoints: {
      280: {
        slidesPerView: 1.15,
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
      768: {
        slidesPerView: 1.8,
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
      992: {
        slidesPerView: 2.2,
        spaceBetween: 20,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    },
  });
});

const newsletterPopup = document.querySelector(".blog-popup-main-wrapper");
if (newsletterPopup) {
  let isClosed = false;

  let popupIsClosed = sessionStorage.getItem("blog-popup-closed");
  if (popupIsClosed !== "true") {
    window.addEventListener("scroll", () => {
      if (!isClosed) {
        if (window.scrollY > 1000) {
          newsletterPopup.classList.add("show");
        }
      }
    });
  }

  const closePopup = newsletterPopup.querySelector(".popup-close");
  closePopup.addEventListener("click", () => {
    newsletterPopup.classList.remove("show");
    isClosed = true;
    sessionStorage.setItem("blog-popup-closed", "true");
  });
}
